module.exports = __webpack_public_path__ + "img/logoeawag.604db1d1.png";